import styled from "styled-components";

import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";
import { onexonePicture, onexoneBoxTtile } from "../mixins-modules";

export const ContentOnexOne = styled.div`
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
  width: auto;
  height: auto;
  flex-direction: column;
  .content {
    width: 100%;
  }
  .mt {
    order: 2;
    margin-top: 20px;
    ${onexoneBoxTtile}
    ${(props) => props.mamsEnabled && "margin-top:35px"};
    margin-bottom: 0;
    h2.title {
      ${Font.vintageSans}
      font-size: 24px;
      line-height: 30px;
      text-transform: uppercase;
      ${breakpoints.phone} {
        margin-top: 8px;
      }
      &.shortenTitle {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        /* min-height: 75px; */
        ${breakpoints.phone} {
          min-height: auto;
          -webkit-line-clamp: inherit;
        }
      }
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
    .volanta,
    .data-txt {
      display: none;
    }
    .bajada {
      ${Font.vintageGeorgia}
      font-size: 15px;
      line-height: 20px;
      color: ${Color.black000};
      margin-top: 5px;
      display: -webkit-box;
      -webkit-line-clamp: 5; /* Número de líneas a mostrar */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis; /* Muestra puntos suspensivos */
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
    .bottomSummary {
      margin-top: 5px;
      ${breakpoints.phone} {
        margin: 8px 0 0 0;
      }
    }
  }
  .content {
    order: 1;
  }
  .date {
    text-align: center;
    ${Font.vintageGeorgia}
    font-size: 15px;
    color: ${Color.black000};
    padding-bottom: 18px;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }
  picture {
    ${onexonePicture}
    height: auto;
    img {
      width: 100% !important;
      height: 260px !important;
      //filter: grayscale(1);
      ${breakpoints.phone} {
        height: auto !important;
      }
    }
  }
  .host-container {
    order: 3;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 18px;
    ${breakpoints.phone} {
      margin-bottom: 15px;
    }
    .host-img-container {
      img {
        //filter: grayscale(1);
      }
    }
    .host-info {
      width: 70%;
      .host-info-intro,
      .host-info-description {
        ${Font.vintageGeorgia}
        font-size: 12px;
        line-height: 15px;
        color: ${Color.black000};
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            color: ${ColorDark.textLight};
          }
        }
      }
      .host-info-name {
        ${Font.vintageGeorgiaBold}
        font-size: 16px;
        line-height: 22px;
        color: ${Color.black000};
        text-transform: uppercase;
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            color: ${ColorDark.textLight};
          }
        }
      }
    }
  }
`;
